/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { ChakraProps } from '@chakra-ui/react';
import type { LottieProps as ReactLottieProps } from 'react-lottie';
import ReactLottie from 'react-lottie';

export type LottieProps = Partial<ReactLottieProps> &
  ChakraProps & {
    loop?: boolean;
    path?: string;
  };
export const Lottie = ({
  path,
  loop = true,
  options,
  style,
  ...props
}: LottieProps) => {
  return (
    <ReactLottie
      options={{
        loop,
        // use canvas to improve performance
        // @ts-ignore
        renderer: 'canvas',
        // @ts-ignore
        path,
        ...options,
      }}
      isClickToPauseDisabled
      style={{
        cursor: 'auto',
        ...style,
      }}
      {...props}
    />
  );
};
